<template>
  <div class="page-wrapper">
    <Tabs :animated="false"  @on-click="tabPage">
      <TabPane label="年龄限制" name="1">
        <age-limit :n="getWhiteList"></age-limit>
      </TabPane>
      <TabPane label="特殊折扣" name="2">
        <special-disc :n="getDiscountList"></special-disc>
      </TabPane>
      <TabPane label="虚拟抵扣" name="3">
        <virtual-credit :n="getVirtualCredit"></virtual-credit>
      </TabPane>
    </Tabs>
  </div>
</template>

<script type="text/ecmascript-6">
  import AgeLimit from './components/AgeLimit/index';
  import SpecialDisc from './components/SpecialDisc/index';
  import VirtualCredit from './components/VirtualCredit/index';

  export default {
    name:'specialrules',
    mounted(){
      this.getWhiteList++
    },
    components: {
      AgeLimit,
      SpecialDisc,
      VirtualCredit
    },
    data() {
      return {
        getWhiteList:0,
        getDiscountList:0,
        getVirtualCredit:0
      }
    },
    methods:{
      tabPage(name){
        // console.log(name)
        switch (name) {
          case '1':
            this.getWhiteList++
            break;
          case '2':
            this.getDiscountList++
            break;
          case '3':
            this.getVirtualCredit++
            break;
        }
      }
    }
  }
</script>

<style scoped>
</style>
